import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

// Make all /api calls go to your Worker
const API_URL = import.meta.env.VITE_API_URL; // prend .env.production en prod

const originalFetch = window.fetch;
window.fetch = (input, init) => {
  if (typeof input === 'string' && input.startsWith('/api')) {
    // s’assure qu’il y a bien un / entre API_URL et path
    input = API_URL.replace(/\/$/, '') + input;
  }
  return originalFetch(input, init);
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);